import * as z from "zod";

export const updatePublishedAt = {
  name: "updatePublishedAt" as const,
  input: z.object({ formId: z.string(), publishedAt: z.date() }),
  output: z.literal("success"),
};
